import { Routes, Route } from 'react-router-dom';
import BoardsList from './BoardsList';
import BoardView from './BoardView';

export default function TasksPage() {
    return (
        <Routes>
            <Route index element={<BoardsList />} />
            <Route path=":boardId" element={<BoardView />} />
        </Routes>
    );
}
